import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { EmbeddingContext, VisualExperience } from 'amazon-quicksight-embedding-sdk/dist';
import { Logger } from 'common/utility/logger/logger';
import { Strings } from 'common/utility/string/string';
import { take } from 'rxjs';
import { UserReportsService } from 'services/user-reports/user-reports.service';
import { Environment } from 'src/environments/environment';


@Component({
  selector: 'ems-user-reports',
  templateUrl: './user-reports.component.html',
  styleUrls: ['./user-reports.component.scss']
})
export class UserReportsComponent implements OnInit {
  @ViewChild("visualContainer") containerDiv: ElementRef | undefined;

  public selectedReportId!: number | undefined
  public currentReport!: any
  private visual: VisualExperience | undefined;

  public userForm!: FormGroup;
  public selectedStart!: number | undefined
  public timestamps: Array<number> | undefined = this.createTimestamps()


  public get ReportName(): string {
    return this.currentReport?.displayName ?? Strings.Empty;
  }

  public get Reports(): Array<any> {
    return this.reportService.Reports
  }

  public dashboardSelectionChanged() {
    this.currentReport = this.Reports.find((report) => report.id === this.selectedReportId)
    this.getVisual()
  }

  public async Visual(embeddedURL: any) {
    // var containerDiv = document.getElementById("visualContainer") || '';

    const frameOptions = {
      url: embeddedURL,
      container: this.containerDiv?.nativeElement,
      height: "850px",
      width: "100%",
      resizeHeightOnSizeChangedEvent: true,
      sandbox: "allow-same-origin"
    }

    const contentOptions = {
      parameters: this.getParameters()
    }

    this.clearContainer()
    const embeddingContext: EmbeddingContext = await createEmbeddingContext();
    this.visual = await embeddingContext.embedVisual(frameOptions, contentOptions);
    Logger.debug("Visual ID:", this.visual)
  }

  public startChanged() {
    // Update report parameter with selectedStart value for parameter SentStart
    this.visual?.setParameters(this.getParameters())

  }

  constructor(
    private reportService: UserReportsService,
    private http: HttpClient,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
  ) { }


  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      timestampStart: null
    });
  }


  private getVisual() {
    const url: string = `${Environment.ReportsApi}/visual?${this.getQueryString()}`
    Logger.debug("Quicksight Url:", url)

    this.http.get(url)
      .pipe(
        take(1),
      )
      .subscribe((data: any) => {
        const reportUrl: string = data.url
        Logger.debug("Connecting to reports with url:", reportUrl)
        this.Visual(reportUrl)
      });
  }


  private getQueryString(): string {
    const parameters: HttpParams = new HttpParams()
      .set('dashboardId', this.currentReport?.dashboardId)
      .set('sheetId', this.currentReport?.sheetId)
      .set('visualId', this.currentReport?.visualId)

    const returnValue: string = parameters.toString()
    return returnValue
  }

  private getParameters(): Array<any> {
    return [
      {
        Name: 'Sent',
        Values: [this.selectedStart]
      }
    ]
  }

  private clearContainer() {
    this.renderer.setProperty(this.containerDiv?.nativeElement, 'innerHTML', "")
  }

  private   createTimestamps(): number[] | undefined {
    return [
      1692316152269
      , 1692316152989
      , 1692316153110
      , 1692316153966
      , 1692316157278
      , 1692316157999
      , 1692316158149
      , 1692316158968
      , 1692316160179
      , 1692316160983
      , 1692316159992
      , 1692316159255
      , 1692316162988
      , 1692316162273
      , 1692316161984
      , 1692316161254
      , 1692316163981
      , 1692316163248
      , 1692316166954
      , 1692316166268
      , 1692316166014
      , 1692316165179
      , 1692316164976
      , 1692316164246
      , 1692316169036
      , 1692316168248
      , 1692316167985
      , 1692316167278
      , 1692316154116
      , 1692316154990
      , 1692316169999
      , 1692316169149
      , 1692316155248
      , 1692316155986
      , 1692316156106
      , 1692316156970
    ]
  }

}
